<template>

  <div class="layoutDetail">
    <el-dialog v-model="dialogVisible" :title="title" @close="dialogClose" >
      <span class="content">{{content}}</span>
      <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确认</el-button>
      </span>
      </template>
    </el-dialog>
  </div>

</template>

<script>
  import {ref, reactive, getCurrentInstance, onMounted} from 'vue'

  export default {
    name: "LayoutDetail",
    props: {
      title: {
        type: String,
        default: '',
      },
      content: {
        type: String,
        default: '',
      },
    },
    setup(){


      // data
      let dialogVisible = ref(false)



      // methods
      function dialogClose() {
        dialogVisible.value = false;
      }



      return{ dialogVisible,
        dialogClose,
      }
    },//setup
  }
</script>

<style scoped lang="less">

  .layoutDetail{

    .content{
      //font-size: 14px;
      height: 26px;
      line-height: 26px;
    }

  }

</style>